export const Impressum = () => {
    return (
        <div className="section-padding container-custom min-h-screen !pt-48 pb-20">
            <h1 className="text-3xl md:text-5xl font-semibold text-[#F1F5F9] mb-12 font-['DM_Sans']">
                Impressum
            </h1>

            <div className="space-y-8 text-[#94A3B8] max-w-3xl">
                <section>
                    <h2 className="text-xl text-[#F1F5F9] font-medium mb-2">Angaben gemäß § 5 TMG</h2>
                    <p>
                        Koray Yildiz<br />
                        Rielassinger 62<br />
                        78224 Singen<br />
                        Deutschland
                    </p>
                </section>

                <section>
                    <h2 className="text-xl text-[#F1F5F9] font-medium mb-2">Vertreten durch</h2>
                    <p>Koray Yildiz (Einzelunternehmen)</p>
                </section>

                <section>
                    <h2 className="text-xl text-[#F1F5F9] font-medium mb-2">Kontakt</h2>
                    <p>
                        Telefon: +41 77 993 89 89<br />
                        E-Mail: info@praesidium-protection.ch
                    </p>
                </section>

                <section className="pt-8 border-t border-[#1E293B]">
                    <h2 className="text-xl text-[#F1F5F9] font-medium mb-4">Haftungsausschluss (Disclaimer)</h2>

                    <h3 className="text-lg text-[#F1F5F9] font-medium mb-2">Haftung für Inhalte</h3>
                    <p className="mb-4">
                        Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                    </p>
                    <p className="mb-4">
                        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                    </p>

                    <h3 className="text-lg text-[#F1F5F9] font-medium mb-2">Haftung für Links</h3>
                    <p className="mb-4">
                        Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
                    </p>
                    <p className="mb-4">
                        Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                    </p>

                    <h3 className="text-lg text-[#F1F5F9] font-medium mb-2">Urheberrecht</h3>
                    <p className="mb-4">
                        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
                    </p>
                    <p className="mb-4">
                        Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                    </p>
                </section>
            </div>
        </div>
    );
};

